import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { SpacePlanPaymentInfo } from '../../../../types';
import { PlanPaymentFormType } from '../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../types';

export const useManagePlanPaymentFormEffects = (
  methods: UseFormReturn<PlanPaymentFormType>,
  planPaymentInfo: SpacePlanPaymentInfo | undefined,
) => {
  const { watch, setValue } = methods;

  const watchedPlanTemplateType = watch('planTemplateType');
  const watchedMaxCcu = watch('maxCcu');
  const watchedOnetimePeriod = watch('onetimePeriod');

  // Handle isCardRegistered logic
  useEffect(() => {
    if (watchedPlanTemplateType === PlanTemplateType.PRODUCT_ONETIME) {
      setValue('isCardRegistered', true);
    } else if (
      watchedPlanTemplateType === PlanTemplateType.PRODUCT_SUBSCRIPTION &&
      planPaymentInfo?.billingInfo
    ) {
      setValue('isCardRegistered', true);
    } else {
      setValue('isCardRegistered', false);
    }
  }, [planPaymentInfo?.billingInfo, setValue, watchedPlanTemplateType]);

  // Handle maxCcu logic
  useEffect(() => {
    if (
      watchedMaxCcu >= 300 &&
      watchedPlanTemplateType === PlanTemplateType.PRODUCT_ONETIME &&
      watchedOnetimePeriod?.includes('M')
    ) {
      setValue('onetimePeriod', '1D');
    }
  }, [watchedMaxCcu, setValue, watchedPlanTemplateType, watchedOnetimePeriod]);

  // Handle custom onetime period logic
  useEffect(() => {
    if (watchedOnetimePeriod?.includes('M')) {
      setValue('isCustomOnetimePeriod', true);
    } else {
      setValue('isCustomOnetimePeriod', false);
    }
  }, [setValue, watchedOnetimePeriod]);
};
